import classnames from 'classnames';
import moment from 'moment';
import { number, oneOf, string } from 'prop-types';
import React from 'react';
import { Label } from 'reactstrap';

import CurrencyFormat from '../../generic/CurrencyFormat';
import InfoTooltip from '../../generic/Tooltip/InfoTooltip';
import { offSiteMinBudgetShape } from '../../prop-types';
import { getOffSiteMinBudget } from '../utils/offsite-min-budget';

function OffSiteMinBudgetCalculator({
  id,
  specification,
  startDate,
  endDate,
  countriesCount,
  serviceValue,
  layout,
}) {
  const numberOfDays = moment(endDate).diff(moment(startDate), 'days') + 1; // The timestamps are midnight, but the last day is wholly included in the campaign
  const { baseBudget, additionalBudgetPerCountry } = specification;

  if (
    numberOfDays <= 0 ||
    countriesCount <= 0 ||
    baseBudget <= 0 ||
    additionalBudgetPerCountry <= 0
  ) {
    return null;
  }

  const minOffSiteBudget = getOffSiteMinBudget(
    baseBudget,
    additionalBudgetPerCountry,
    countriesCount,
    numberOfDays,
  );
  const amountClass = classnames('ml-2', {
    'text-warning': serviceValue < minOffSiteBudget,
  });
  return (
    <div className={`c-offsite-min-budget-calculator d-flex flex-${layout}`}>
      <Label className="m-0">
        Min value
        <InfoTooltip className="ml-2" target={`minSpend-${id}`}>
          The recommended minimum budget for this product based on the number of
          countries and the runtime
        </InfoTooltip>
      </Label>
      <CurrencyFormat className={amountClass} text value={minOffSiteBudget} />
    </div>
  );
}

OffSiteMinBudgetCalculator.propTypes = {
  id: number.isRequired,
  specification: offSiteMinBudgetShape.isRequired,
  startDate: string.isRequired,
  endDate: string.isRequired,
  countriesCount: number.isRequired,
  serviceValue: number.isRequired,
  layout: oneOf(['row', 'column']),
};

OffSiteMinBudgetCalculator.defaultProps = {
  layout: 'column',
};

export default OffSiteMinBudgetCalculator;
